var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPlayback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 26 26",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9A5D",
    d: "M22.1 22.1H3.9V3.9h18.2zM5.2 20.8h2.837v-2.6H5.2zm4.255 0h2.836v-2.6H9.455zm4.254 0h2.837v-2.6h-2.837zm4.255 0H20.8v-2.6h-2.837zm-6.58-11.109a.65.65 0 0 0-.984.557v5.504a.65.65 0 0 0 .984.557l4.587-2.752a.65.65 0 0 0 0-1.114zM5.2 7.801h2.837V5.2H5.2zm4.255 0h2.836V5.2H9.455zm4.254 0h2.837V5.2h-2.837zM17.964 5.2v2.6H20.8V5.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlayback);
export default __webpack_public_path__ + "static/media/IcoPlayback.80e22cefbc573e9bf3fa33113e300315.svg";
export { ForwardRef as ReactComponent };